export const emptyBasicInfoForm = {
  listingTitle: '',
  listingDescription: '',
  providerCategory: { label: '', value: 0 },
  aoiSpecialty: { label: '', value: '' },
  subspecialties: [] as { label: string; value: string }[],
  generalSpecialtyFlag: true,
  isRenewable: false,
  workLocation: { label: 'Remote', value: 'REMOTE' },
};

export const WORK_LOCATION_OPTIONS = [
  { label: 'Onsite', value: 'ONSITE' },
  { label: 'Partial Remote', value: 'PARTIAL_REMOTE' },
  { label: 'Remote', value: 'REMOTE' },
];
